<template>
  <div>
    <div class="dataTime">
      <span class="demonstration">{{$t('BatteryAnalysis.date')}}</span>
      <el-date-picker
        v-model="changeValue"
        value-format="yyyy-MM-dd"
        type="daterange"
        :range-separator="$t('BatteryAnalysis.to')"
        :start-placeholder="$t('BatteryAnalysis.starDate')"
        :end-placeholder="$t('BatteryAnalysis.endDate')"
        @change="changeTime"
      >
      </el-date-picker>
    </div>
    <div class="dataEchart">
      <div style="padding: 10px 0 0 10px; color: #fff; font-size: 18px">
        {{$t('BatteryAnalysis.chargeAndDischargeTimeH')}}
      </div>
      <div v-loading="amountLoading">
        <linegraph
          :id="'linegraph'"
          :data="amountOption"
          style="height: 310px"
        ></linegraph>
      </div>
    </div>
    <div class="dataTable">
      <div class="table-title">{{$t('BatteryAnalysis.carUseDetail')}}</div>
      <div class="rightAll-btn" v-if="isShow">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item :label="$t('BatteryAnalysis.batteryNumber')">
            <el-input
              size="mini"
              v-model="formInline.batteryNumber"
              :placeholder="$t('BatteryAnalysis.form.batteryNumber')"
              style="width: 150px"
              class="input-with-select"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('BatteryAnalysis.carId')">
            <el-input
              size="mini"
              v-model="formInline.carId"
              :placeholder="$t('BatteryAnalysis.form.carId')"
              style="width: 150px"
              class="input-with-select"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('BatteryAnalysis.terminalId')">
            <el-input
              size="mini"
              v-model="formInline.terminalId"
              :placeholder="$t('common.searchTip')"
              style="width: 150px"
              class="input-with-select"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              size="mini"
              type="primary"
              @click="onSearch"
              class="btn-chaxun"
              >{{$t('common.btn.search')}}</el-button
            >
            <el-button size="mini" @click="onClear" class="btn-del"
              >{{$t('common.btn.cancel')}}</el-button
            >
          </el-form-item>
        </el-form>
        <el-button v-if="isPrimaryKey('BATTERYANALYSIS_DOWN')" type="text" @click="downCar">{{$t('common.btn.download')}}</el-button>
      </div>
      <div class="rightAll-btn" v-else>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item :label="$t('BatteryAnalysis.isWarningStr')">
            <el-select v-model="formInline.warningType" :placeholder="$t('common.choseTip')">
              <el-option :label="$t('common.all')" value=""></el-option>
              <el-option :label="$t('BatteryAnalysis.normal')" value="0"></el-option>
              <el-option :label="$t('BatteryAnalysis.abnormal')" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              size="mini"
              type="primary"
              @click="onSearch"
              class="btn-chaxun"
              >{{$t('common.btn.search')}}</el-button
            >
            <el-button size="mini" @click="onClear" class="btn-del"
              >{{$t('common.btn.cancel')}}</el-button
            >
          </el-form-item>
        </el-form>
        <el-button v-if="isPrimaryKey('BATTERYANALYSIS_DOWN')" type="text" @click="down">{{$t('common.btn.download')}}</el-button>
      </div>
      <i-table
        :list="list"
        ref="carTable"
        @handleSelectionChange="handleSelectionChange"
        :options="option"
        :columns="columns"
        :operates="operates"
      ></i-table>
      <IPagination ref="page" @PageFun="changeSize"></IPagination>
    </div>
  </div>
</template>

<script>
import ChangeTime from "./ChangeTime";
export default ChangeTime;
</script>

<style lang="less" scoped>
@import "../../../../assets/styles/Style.less";
</style>
